<template>
    <div>
        HELLO, POLL
    </div>
</template>

<script>
export default {
    name: "Poll",
    data: () => ({
        
    })
}
</script>

<style>

</style>